export const Base = {
  name: '上海小紫医疗科技有限公司',
  address: '上海市普陀区金沙江路1340弄172支弄14号3幢3层西侧D座',
  phone: '13585920377',
  owner: '李振成',
  fax: '--',
  contactPhone: '13585920377',
};
